import { all, spawn } from 'redux-saga/effects';
import authSaga from './auth';
import codeSaga from './code';
import countrySaga from './country';
import emailSaga from './email';
import organizationSaga from './organization';
import organizationSurveySaga from './organizationSurvey';
import profileSaga from './profile';
import surveySaga from './survey';
import userSaga from './user';

export default function* sagas() {
  yield all([spawn(authSaga)]);
  yield all([spawn(surveySaga)]);
  yield all([spawn(organizationSaga)]);
  yield all([spawn(userSaga)]);
  yield all([spawn(organizationSurveySaga)]);
  yield all([spawn(profileSaga)]);
  yield all([spawn(countrySaga)]);
  yield all([spawn(codeSaga)]);
  yield all([spawn(emailSaga)]);
}
